
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13148',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13148",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.493",
  "data-fetching-client": "static-1.9916",
  "foundations-components": "static-1.8416",
  "foundations-components-legacy": "static-1.1441",
  "foundations-theming": "static-1.4726",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.86",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8287",
  "hub-http-shared-msw-handlers": "static-1.10547",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11743",
  "I18n": "static-7.1665",
  "jasmine-runner": "static-1.6708",
  "marketplace-discovery-studio-lib": "static-1.571",
  "marketplace-storefront-base": "static-1.13211",
  "quartz": "static-1.7393",
  "react-dlb": "static-1.86",
  "react-rhumb": "static-1.16970",
  "reactive-variable-buffer-atom": "static-1.3115",
  "reporting-testing-lib": "static-1.10581",
  "reselect": "static-3.9",
  "settings-ui-lib": "static-1.12780",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7578",
  "ui-addon-i18n": "static-1.11402",
  "ui-addon-react-router-dom": "static-1.9796",
  "unified-auth": "static-1.832",
  "unified-auth-core-lib": "static-1.1114",
  "usage-tracker": "static-1.7616",
  "usage-tracker-core": "static-1.7466",
  "customer-data-property-utils": "static-1.8356",
  "hub-http": "static-1.6472",
  "integrations-lib": "static-1.16954",
  "marketplace-ui-common": "static-1.20631",
  "marketplace-ui-install": "static-1.617",
  "property-management-iframe": "static-1.14034",
  "quartz-config": "static-1.1171",
  "quartz-core": "static-1.6612",
  "quartz-routing": "static-1.823",
  "quick-fetch": "static-1.4103",
  "react": "static-7.191",
  "rpc-client-utils": "static-1.4922",
  "ts-schema": "static-1.4265",
  "ui-universal-auth": "static-1.9318",
  "UIComponents": "static-3.8689",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3590",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3670",
  "quartz-webpack": "static-1.3617",
  "bend-plugin-quartz-routing": "static-1.471",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4685",
  "floating-ui": "static-1.62",
  "foundations-assets": "static-1.5143",
  "foundations-theming-specialty": "static-1.2442",
  "framer-motion": "static-1.76",
  "hs-story-utils": "static-1.9686",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.64",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5527",
  "react-virtualized": "static-2.104",
  "StyleGuideUI": "static-3.496",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2514",
  "ui-fonts": "static-1.1005",
  "ui-images": "static-2.1233",
  "bend-plugin-foundations-theming": "static-1.3209",
  "foundations-theming-base": "static-1.3711",
  "stylex": "static-1.38",
  "HeadJS": "static-2.790",
  "hs-test-utils-bend-plugin": "static-1.3398",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.228",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4575",
  "ui-addon-video-player": "static-1.8963",
  "ai-components-ui-library": "static-1.9625",
  "ai-rendering-library": "static-1.11028",
  "chirp-fetch": "static-1.2153",
  "connections-embed-lib": "static-1.1447",
  "copilot-toolkit": "static-1.11771",
  "feedback-loader": "static-1.29752",
  "laboratory-lib": "static-3.7411",
  "marketplace-embed": "static-1.22844",
  "marketplace-ui-details": "static-1.10526",
  "marketplace-ui-reviews": "static-1.20586",
  "marketplace-ui-tracking": "static-1.14801",
  "sanitize-text": "static-1.8410",
  "usage-tracker-multi": "static-1.6030",
  "usage-tracker-session-replay": "static-1.5302",
  "wootric-nps": "static-1.7171",
  "quartz-head": "static-1.1058",
  "web-vitals": "static-1.11",
  "apollo-link-hub-http": "static-2.4915",
  "immer": "static-1.94",
  "immerable": "static-1.4410",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2652",
  "reporting-data": "static-1.68648",
  "cssUtils": "static-1.876",
  "flux-actions": "static-1.362",
  "HubStyle": "static-2.12050",
  "PatternValidationJS": "static-1.3157",
  "react-colorpicker": "static-2.10467",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10627",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7606",
  "icons": "static-2.675",
  "marketplace-ui-apps-core": "static-1.19163",
  "storybook-react": "static-1.37",
  "trellis-story-utils": "static-1.4770",
  "foundations-components-test-utils": "static-1.5899",
  "quartz-i18n": "static-1.1068",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.379",
  "ads-unified-auth-lib": "static-1.1130",
  "google-sheets-integration-lib": "static-1.955",
  "microsoft-drive-auth-lib": "static-1.51",
  "surveymonkey-integration-lib": "static-1.399",
  "slack-ui-library": "static-1.10658",
  "fsm": "static-1.4000",
  "customer-data-objects": "static-1.7947",
  "property-translator": "static-1.5656",
  "hs-locale-management": "static-1.264",
  "frontend-preferences-client": "static-1.8186",
  "hs-promise-utils": "static-1.5854",
  "hubspot-apollo-client": "static-1.5138",
  "integrations-error-boundary-lib": "static-1.14369",
  "integrations-tracking-lib": "static-1.5867",
  "native-integrations-shared-strings": "static-1.8037",
  "sanitize": "static-1.4735",
  "superstore": "static-1.5015",
  "ui-shepherd-react": "static-3.10524",
  "ai-settings-ui-library": "static-1.8270",
  "hub-http-janus": "static-1.871",
  "hubspotter-http": "static-1.4835",
  "immutable-less": "static-1.4910",
  "marketplace-ui-client-types": "static-1.18038",
  "nav-meta": "static-1.30373",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18332",
  "ui-product-approvals-common": "static-1.913",
  "ai-studio-lib": "static-1.12386",
  "hubspot-prosemirror": "static-1.18895",
  "integrations-reconnect-lib": "static-1.420",
  "ui-addon-iframeable": "static-1.9334",
  "ui-addon-integrations-directory-panel": "static-2.8285",
  "ui-product-approvals": "static-1.29018",
  "ui-tool-access": "static-1.10413",
  "inbound-db-properties-service-client": "static-1.4029",
  "property-management-common": "static-1.6322",
  "opentelemetry-fe-types": "static-1.29",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.569",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.404",
  "quartz-auth": "static-1.1068",
  "quartz-test": "static-1.1068",
  "quartz-tracking": "static-1.772",
  "trellis-components": "static-1.2533",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.332",
  "bender-build-tools": "static-1.3392",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22711",
  "ContentUtils": "static-1.69063",
  "customer-data-objects-ui-components": "static-1.13289",
  "sassPrefix": "static-1.163",
  "avatar-components": "static-1.2754",
  "breeze-engine-core": "static-1.882",
  "breeze-onboarding-components": "static-1.643",
  "customer-data-filters-ui": "static-1.40793",
  "customer-data-reference-ui-components": "static-1.13439",
  "embedded-academy-lib": "static-1.15403",
  "ExportDialog": "static-6.10638",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41939",
  "reporting-snowflake": "static-1.57265",
  "reporting-ui-components": "static-2.65918",
  "reporting-visualizations": "static-1.60723",
  "trial-components-library": "static-1.14043",
  "trellis-theming": "static-1.1226",
  "ui-addon-teams": "static-1.21867",
  "upgrade-components-lib": "static-1.469",
  "magpie-lib": "static-1.5727",
  "navigation-components": "static-1.18736",
  "breeze-engine-lib": "static-1.1604",
  "magpie-types": "static-1.5187",
  "simple-logging-lib": "static-1.3310",
  "fail-safe": "static-1.213",
  "app-governance-lib": "static-1.2320",
  "developer-experience-shared-components": "static-1.10763",
  "purchase-motions-components": "static-1.6298",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.10084",
  "usage-tracker-anonymous": "static-1.6033",
  "usage-tracker-public": "static-1.7427",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3957",
  "reference-resolvers": "static-1.8439",
  "ui-extensibility-client-types": "static-1.4180",
  "hubspot-apollo-cache": "static-1.597",
  "universal-page-editor-lib": "static-1.3266",
  "final-form": "static-1.75",
  "redux-toolkit": "static-1.75",
  "simple-data-table": "static-1.3460",
  "atom": "static-1.5345",
  "merchandise-lib": "static-1.274",
  "salesImages": "static-1.531",
  "codemirror": "static-5.99",
  "react-codemirror": "static-1.10898",
  "ui-addon-draggable": "static-3.5014",
  "content-assistance-lib": "static-1.8146",
  "content-media-capture": "static-1.5341",
  "customer-data-ui-utilities": "static-1.10087",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24394",
  "growth-payments-core": "static-1.26100",
  "knowledge-content-types": "static-1.8627",
  "payment-link-components": "static-1.24097",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20250",
  "ui-addon-emoji-picker": "static-1.10145",
  "ui-business-units-lib": "static-1.9343",
  "video-components-external": "static-1.12085",
  "video-data-lib": "static-1.35743",
  "navigation-messaging": "static-1.8063",
  "collaboration-sidebar": "static-1.58639",
  "react-dnd-compat": "static-1.4875",
  "batch-promise": "static-1.1800",
  "crm-component-utils": "static-1.39754",
  "crm-properties-common-lib": "static-1.6149",
  "customer-data-properties": "static-1.52469",
  "external-options-client-types": "static-1.4312",
  "framework-data-schema-resolvers": "static-1.7152",
  "property-value-citations": "static-1.3083",
  "reference-resolvers-lite": "static-1.8360",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10545",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "cms-field-types": "static-1.5074",
  "content-icons-ui": "static-1.2323",
  "breeze-artifacts-sdk": "static-1.224",
  "onboarding-journeys-lib": "static-1.818",
  "pulse": "static-1.883",
  "conversations-skeleton-state": "static-1.7508",
  "crm-message-bus": "static-1.43669",
  "customer-data-filters-ui-msw-helpers": "static-1.23228",
  "events-data-lib": "static-1.500",
  "FormUrlGenerator": "static-2.4986",
  "framework-builder-read-service-client": "static-1.4193",
  "hs-resources": "static-1.450",
  "multi-account-reference-resolvers": "static-1.1256",
  "onboarding-scopes": "static-1.6713",
  "onboarding-tours": "static-1.17059",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14391",
  "academy-common-lib": "static-1.14863",
  "dashboard-lib": "static-1.82674",
  "getting-started-shared-tasks": "static-1.19144",
  "hubspot-prosemirror-plugins": "static-1.18887",
  "share-with-third-party-component-lib": "static-1.8964",
  "ui-asset-management-lib": "static-1.11355",
  "user-context": "static-1.5375",
  "reporting-plugins": "static-1.10685",
  "reporting-reports": "static-1.68325",
  "hubs-service-types": "static-1.1518",
  "purchase-motions-api": "static-1.6301",
  "signup-constants": "static-1.19537",
  "idb-keyval": "static-1.48",
  "reactive-lib": "static-1.981",
  "nest": "static-1.495",
  "breeze-engine-chat-components": "static-1.582",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.164",
  "framework-listing-lib": "static-2.29407",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31359",
  "apps-service-types": "static-1.4000",
  "oauth-service-types": "static-1.4507",
  "signup-ui-url-generator": "static-2.8319",
  "onboarding-tours-client": "static-1.5273",
  "one-click-checkout": "static-1.321",
  "platform-infra-nav-components": "static-1.7862",
  "subscription-experience-data-types": "static-1.15213",
  "crm-record-cards-service-types": "static-1.3759",
  "location-customization-utils-lib": "static-1.10016",
  "redux-thunk": "static-2.77",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "react-flip-move": "static-1.75",
  "ui-coaching-tips": "static-1.29239",
  "content-media-composition-data-lib": "static-1.13145",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4685",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.653",
  "ui-addon-opt": "static-4.8625",
  "commerce-tours-lib": "static-1.6553",
  "growth-onboarding-reliability": "static-1.5340",
  "sales-checkout-service-client": "static-1.3788",
  "data-token-picker": "static-1.16832",
  "FileManagerLib": "static-1.40034",
  "content-media-compositions": "static-2.17152",
  "media-bridge-lib": "static-1.19351",
  "chatspot-widget-iframe": "static-1.22702",
  "collaboration-sidebar-common": "static-1.3436",
  "marketing-platform-lib": "static-1.7127",
  "card-properties-lib": "static-1.44929",
  "commerce-subscription-lib": "static-1.37702",
  "crm-actions": "static-1.6610",
  "crm-cards-sdk": "static-1.44426",
  "customer-data-properties-shared-msw-handlers": "static-1.9874",
  "customer-data-tracking": "static-1.7141",
  "calling-global-api": "static-1.65426",
  "calling-internal-common": "static-1.31577",
  "calling-lifecycle-internal": "static-1.66808",
  "calling-lifecycle-messages": "static-1.59102",
  "commerce-products-lib": "static-1.10439",
  "conditional-properties-service-client": "static-1.3985",
  "crm-index-visualization-core": "static-1.4489",
  "crm-links": "static-1.6585",
  "crm-pipelines-api-client-types": "static-1.4319",
  "formula-editor": "static-1.14691",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4396",
  "meetings-icalendar-utils-lib": "static-1.894",
  "multi-currency-client-types": "static-1.3879",
  "object-builder-ui-client": "static-1.49575",
  "pipeline-validation-client-types": "static-1.4154",
  "smart-data-capture-core": "static-1.53",
  "smart-property-lib": "static-1.8200",
  "tiered-pricing": "static-1.1891",
  "topics-actions-lib": "static-1.424",
  "ui-addon-form-validation": "static-1.11245",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.271",
  "framework-data-schema-quick-fetch": "static-1.7057",
  "bend-plugin-pulse": "static-1.386",
  "event-emitter": "static-1.1213",
  "fast-json-patch": "static-1.67",
  "restore-request-side-panel-lib": "static-1.1587",
  "growth-data-modal": "static-1.5835",
  "growth-onboarding-confetti": "static-1.3322",
  "growth-onboarding-next-action-utils": "static-1.2620",
  "onboarding-tours-utils": "static-1.1125",
  "ui-shepherd-tracker": "static-1.7905",
  "academy-service-client": "static-1.3948",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39893",
  "SafeStorage": "static-1.4664",
  "video-embed": "static-1.36577",
  "redux-actions": "static-3.68",
  "EmailSignatureEditor": "static-1.24935",
  "viral-links-lib": "static-1.7332",
  "nested-table": "static-1.494",
  "timezone-utils": "static-2.5506",
  "getting-started-shared-tasks-store": "static-1.18262",
  "campaign-roi-lib": "static-1.10028",
  "ui-addon-calendars": "static-2.5587",
  "customer-data-views-management": "static-1.25954",
  "framework-data-table": "static-2.12475",
  "nudge-client-utils": "static-1.3087",
  "nudge-custom-ui-functions": "static-1.1436",
  "switchboard-lib": "static-1.474",
  "access-check-ui-lib": "static-1.1508",
  "app-users-service-client": "static-1.5879",
  "app-users-service-types": "static-1.5287",
  "mini-checkout-client": "static-1.27416",
  "onboarding-utils": "static-1.5623",
  "permissions-shared-i18n-strings-fe": "static-1.2118",
  "ui-coaching-tips-shared-config": "static-1.29224",
  "checkout-sdk": "static-3.24259",
  "payment-method-components": "static-1.7105",
  "touchless-buying-components": "static-1.6127",
  "upgrade-catalog-service-types": "static-1.3745",
  "edison-service-client-types": "static-1.651",
  "growth-onboarding-feedback-components": "static-1.6844",
  "audio-components": "static-1.6287",
  "FileManagerImages": "static-1.37545",
  "video-components": "static-1.14087",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92750",
  "customer-data-sidebar": "static-2.46666",
  "enrichment-lib": "static-1.187",
  "ui-addon-draggable-compat": "static-2.4523",
  "universal-record-utils-lib": "static-1.1779",
  "commerce-billing-lib": "static-1.20026",
  "commerce-shared-components-lib": "static-1.19150",
  "commerce-tools-ui-lib": "static-1.10977",
  "crm-fe-perf": "static-1.23159",
  "calling-error-reporting": "static-1.31584",
  "shared-worker-versioning": "static-1.11298",
  "calling-usage-tracker": "static-1.6798",
  "voice-sms-access-library": "static-1.1937",
  "commerce-permissions": "static-1.1036",
  "products-iframe-lib": "static-1.8518",
  "products-ui-components-shared-msw-handlers": "static-1.10929",
  "crm-index-associations-lib": "static-1.6701",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10630",
  "sales-views-client-types": "static-1.4516",
  "bark-lib": "static-1.16766",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.588",
  "policy-lib": "static-1.7055",
  "react-tinymce": "static-1.55902",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10693",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55028",
  "tinymce-plugins": "static-1.58142",
  "tinymce-themes": "static-1.56998",
  "onboarding-data-sync-lib": "static-1.2436",
  "growth-onboarding-next-action-components": "static-1.2648",
  "user-context-client": "static-1.4768",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4792",
  "outpost": "static-1.4419",
  "draft-convert": "static-2.77",
  "draft-extend": "static-3.80",
  "draft-js": "static-5.82",
  "draft-plugins": "static-2.22101",
  "sales-email-signature-service-client": "static-1.4105",
  "ts-utils-lib": "static-1.426",
  "crm-export-dialog": "static-1.6543",
  "crm-view-components": "static-1.1024",
  "react-beautiful-dnd": "static-1.67",
  "customer-data-associations": "static-1.7587",
  "tasks-actions-lib": "static-1.45",
  "nudge-custom-function-registry": "static-1.2844",
  "nudge-renderer-utils": "static-1.3163",
  "whisper-core-api": "static-1.7255",
  "InboxConnectUtils": "static-4.15482",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46770",
  "hub-http-rxjs": "static-1.835",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4251",
  "company-details-components": "static-1.6460",
  "react-performance-metrics-lib": "static-1.816",
  "pricing-pages-ui-components": "static-1.15573",
  "quote-checkout-service-types": "static-1.3718",
  "social-insights-client-types": "static-1.22685",
  "crm_universal": "static-1.22441",
  "customer-data-email": "static-1.18468",
  "card-payment-highlight-lib": "static-1.37896",
  "card-subscription-highlight-lib": "static-1.40125",
  "commerce-contract-lib": "static-1.13201",
  "invoices-highlight-card-lib": "static-1.55580",
  "orders-highlight-card-lib": "static-1.22116",
  "products-highlight-card-lib": "static-1.18722",
  "quotes-highlight-card-lib": "static-1.72761",
  "crm-source-interpretation-lib": "static-1.5592",
  "data-agent-utils": "static-1.249",
  "crm-object-search-query-utilities": "static-1.10134",
  "utility-belt": "static-1.2790",
  "payments-enrollment-embed-lib": "static-1.23728",
  "stripe-embedded-components": "static-1.7942",
  "customer-data-rte": "static-1.33581",
  "cv-backend-services": "static-1.1590",
  "growth-onboarding-empty-states": "static-1.6210",
  "payments-post-enroll-local-storage-lib": "static-1.5366",
  "qrcode-generator": "static-1.73",
  "quotes-client-types": "static-1.38851",
  "calling-orchestration-schema": "static-1.36714",
  "react-reducer-toolkit": "static-1.16290",
  "hub-http-contrib": "static-1.3296",
  "interframe": "static-3.5015",
  "tinymce-data": "static-1.41113",
  "ui-addon-sales-email": "static-1.5475",
  "layout-dnd-components": "static-1.12906",
  "layout-dnd-utils": "static-1.11881",
  "ui-brand-identity-lib": "static-1.16277",
  "NamespacedHubStyle": "static-2.9234",
  "meetings-connect-utils-lib": "static-1.7869",
  "access-control-lib": "static-1.10696",
  "EmailComponents": "static-1.55477",
  "EmailData": "static-1.54155",
  "redux-less": "static-2.9737",
  "company-details-service-types": "static-1.4198",
  "segments-query-core": "static-1.1683",
  "pricing-pages-api": "static-1.15438",
  "sequences-lib": "static-1.8481",
  "ui-gdpr-components": "static-1.10616",
  "products-ui-components": "static-1.40957",
  "accounting-integrations-ui-components": "static-1.7484",
  "invoices-ui-lib": "static-1.55596",
  "commerce-products-api": "static-1.2648",
  "invoices-iframe-lib": "static-1.57654",
  "quotes-modal-lib": "static-1.103439",
  "quotes-ui-lib": "static-1.81482",
  "stripe-connect-js": "static-1.75",
  "draft-content-plugins": "static-1.28843",
  "ContentData": "static-1.69138",
  "layout-data-lib": "static-1.10206",
  "ContentComponents": "static-2.72019",
  "marketing-contacts-lib": "static-1.10933",
  "marketing-email-service-types": "static-1.2071",
  "messaging-editing-lib": "static-1.47056",
  "messaging-usage-based-billing-components-lib": "static-1.1918",
  "automation-ui-source-apps": "static-1.19586",
  "automation-ui-types": "static-1.20504",
  "messaging-types-lib": "static-1.46793",
  "onboarding-settings-client": "static-1.4767",
  "sequences-client-types-lib": "static-1.8338",
  "commerce-tax-lib": "static-1.797",
  "price-books-api": "static-1.1657",
  "price-books-components": "static-1.1715",
  "property-description-translator": "static-1.4099",
  "ramp-editor": "static-1.825",
  "commerce-analytics-service-client": "static-1.3776",
  "totals-ui-components": "static-1.24226",
  "SalesContentIndexUI": "static-3.9580",
  "advanced-menus-core": "static-1.15522",
  "advanced-menus-lib": "static-1.12401",
  "ui-memberships-settings-lib": "static-1.34766",
  "automation-ui-ubb": "static-1.6420",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7597",
  "data-token-views": "static-1.16813",
  "forms-utils-lib": "static-1.13037",
  "payments-embed-points-lib": "static-1.13530",
  "simple-menus-core": "static-1.15521",
  "simple-menus-lib": "static-1.17038",
  "videoconference-integration-components": "static-1.7192",
  "marketing-contacts-client": "static-1.7769",
  "mc-hard-limits-client-types": "static-1.163",
  "automation-applications-service-types": "static-1.3648",
  "automation-platform-service-types": "static-1.2659",
  "ContentEditorUI": "static-2.77827",
  "short-messages-app-service-client": "static-1.4176",
  "web-interactives-components": "static-1.14191",
  "web-interactives-data": "static-1.14192",
  "messaging-shared-utils-lib": "static-1.1367",
  "messaging-user-info-utils-lib": "static-1.1537",
  "email-portal-health-service-types": "static-1.1238",
  "line-items-api": "static-1.1046",
  "commerce-totals-service-types": "static-1.4003",
  "FireAlarmUi": "static-1.4690",
  "sales-templates-service-types-lib": "static-1.4356",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22440",
  "automation-ui-usage-tracking": "static-1.21903",
  "data-studio-ubb": "static-1.3435",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27586",
  "content-management-data-lib": "static-1.5895",
  "copilot-plugins": "static-1.11743",
  "cta-picker": "static-1.37017",
  "customer-agent-discovery-components-lib": "static-1.3806",
  "editor-components": "static-1.13594",
  "editor-iframe-lib": "static-1.8746",
  "error-messaging-js": "static-1.5456",
  "FormsCommonComponents": "static-1.86489",
  "pictos": "static-7.190",
  "react-transition-group": "static-2.69",
  "redux-request-state": "static-1.10909",
  "SharedLegalStrings": "static-1.2006",
  "smart-content-core": "static-1.43101",
  "smart-content-lib": "static-1.43754",
  "social-composer-lib": "static-1.60135",
  "structured-content-lib": "static-1.25849",
  "theme-previewer-lib": "static-1.53877",
  "tinymce-copilot": "static-1.17096",
  "xray-recommendation-lib": "static-1.8218",
  "automation-ui-routing": "static-1.21861",
  "sql-reporting-client-types": "static-1.5858",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42720",
  "campaigns-utils-lib": "static-1.3462",
  "reporting-enablement": "static-1.23747",
  "forms-ai-lib": "static-1.4707",
  "codemirror-dlb": "static-1.59386",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6698",
  "report-customization-components": "static-1.13832",
  "data-quality-ui-library": "static-1.13712",
  "reporting-filters": "static-1.936",
  "reporting-insights-lib": "static-1.2491"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13148",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.493",
  "data-fetching-client": "/data-fetching-client/static-1.9916",
  "foundations-components": "/foundations-components/static-1.8416",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1441",
  "foundations-theming": "/foundations-theming/static-1.4726",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.86",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8287",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10547",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11743",
  "I18n": "/I18n/static-7.1665",
  "jasmine-runner": "/jasmine-runner/static-1.6708",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.571",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13211",
  "quartz": "/quartz/static-1.7393",
  "react-dlb": "/react-dlb/static-1.86",
  "react-rhumb": "/react-rhumb/static-1.16970",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3115",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10581",
  "reselect": "/reselect/static-3.9",
  "settings-ui-lib": "/settings-ui-lib/static-1.12780",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7578",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11402",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9796",
  "unified-auth": "/unified-auth/static-1.832",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1114",
  "usage-tracker": "/usage-tracker/static-1.7616",
  "usage-tracker-core": "/usage-tracker-core/static-1.7466",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8356",
  "hub-http": "/hub-http/static-1.6472",
  "integrations-lib": "/integrations-lib/static-1.16954",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20631",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.617",
  "property-management-iframe": "/property-management-iframe/static-1.14034",
  "quartz-config": "/quartz-config/static-1.1171",
  "quartz-core": "/quartz-core/static-1.6612",
  "quartz-routing": "/quartz-routing/static-1.823",
  "quick-fetch": "/quick-fetch/static-1.4103",
  "react": "/react/static-7.191",
  "rpc-client-utils": "/rpc-client-utils/static-1.4922",
  "ts-schema": "/ts-schema/static-1.4265",
  "ui-universal-auth": "/ui-universal-auth/static-1.9318",
  "UIComponents": "/UIComponents/static-3.8689",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3590",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3670",
  "quartz-webpack": "/quartz-webpack/static-1.3617",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.471",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4685",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-assets": "/foundations-assets/static-1.5143",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2442",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-story-utils": "/hs-story-utils/static-1.9686",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.64",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5527",
  "react-virtualized": "/react-virtualized/static-2.104",
  "StyleGuideUI": "/StyleGuideUI/static-3.496",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2514",
  "ui-fonts": "/ui-fonts/static-1.1005",
  "ui-images": "/ui-images/static-2.1233",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3209",
  "foundations-theming-base": "/foundations-theming-base/static-1.3711",
  "stylex": "/stylex/static-1.38",
  "HeadJS": "/HeadJS/static-2.790",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3398",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.228",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4575",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8963",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9625",
  "ai-rendering-library": "/ai-rendering-library/static-1.11028",
  "chirp-fetch": "/chirp-fetch/static-1.2153",
  "connections-embed-lib": "/connections-embed-lib/static-1.1447",
  "copilot-toolkit": "/copilot-toolkit/static-1.11771",
  "feedback-loader": "/feedback-loader/static-1.29752",
  "laboratory-lib": "/laboratory-lib/static-3.7411",
  "marketplace-embed": "/marketplace-embed/static-1.22844",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10526",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20586",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14801",
  "sanitize-text": "/sanitize-text/static-1.8410",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6030",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5302",
  "wootric-nps": "/wootric-nps/static-1.7171",
  "quartz-head": "/quartz-head/static-1.1058",
  "web-vitals": "/web-vitals/static-1.11",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4915",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4410",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2652",
  "reporting-data": "/reporting-data/static-1.68648",
  "cssUtils": "/cssUtils/static-1.876",
  "flux-actions": "/flux-actions/static-1.362",
  "HubStyle": "/HubStyle/static-2.12050",
  "PatternValidationJS": "/PatternValidationJS/static-1.3157",
  "react-colorpicker": "/react-colorpicker/static-2.10467",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10627",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7606",
  "icons": "/icons/static-2.675",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19163",
  "storybook-react": "/storybook-react/static-1.37",
  "trellis-story-utils": "/trellis-story-utils/static-1.4770",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5899",
  "quartz-i18n": "/quartz-i18n/static-1.1068",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.379",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1130",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.955",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.51",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.399",
  "slack-ui-library": "/slack-ui-library/static-1.10658",
  "fsm": "/fsm/static-1.4000",
  "customer-data-objects": "/customer-data-objects/static-1.7947",
  "property-translator": "/property-translator/static-1.5656",
  "hs-locale-management": "/hs-locale-management/static-1.264",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8186",
  "hs-promise-utils": "/hs-promise-utils/static-1.5854",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5138",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14369",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5867",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8037",
  "sanitize": "/sanitize/static-1.4735",
  "superstore": "/superstore/static-1.5015",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10524",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8270",
  "hub-http-janus": "/hub-http-janus/static-1.871",
  "hubspotter-http": "/hubspotter-http/static-1.4835",
  "immutable-less": "/immutable-less/static-1.4910",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18038",
  "nav-meta": "/nav-meta/static-1.30373",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18332",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.913",
  "ai-studio-lib": "/ai-studio-lib/static-1.12386",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18895",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.420",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9334",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8285",
  "ui-product-approvals": "/ui-product-approvals/static-1.29018",
  "ui-tool-access": "/ui-tool-access/static-1.10413",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4029",
  "property-management-common": "/property-management-common/static-1.6322",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.29",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.569",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.404",
  "quartz-auth": "/quartz-auth/static-1.1068",
  "quartz-test": "/quartz-test/static-1.1068",
  "quartz-tracking": "/quartz-tracking/static-1.772",
  "trellis-components": "/trellis-components/static-1.2533",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.332",
  "bender-build-tools": "/bender-build-tools/static-1.3392",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22711",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13289",
  "sassPrefix": "/sassPrefix/static-1.163",
  "avatar-components": "/avatar-components/static-1.2754",
  "breeze-engine-core": "/breeze-engine-core/static-1.882",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.643",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40793",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13439",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15403",
  "ExportDialog": "/ExportDialog/static-6.10638",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41939",
  "reporting-snowflake": "/reporting-snowflake/static-1.57265",
  "reporting-ui-components": "/reporting-ui-components/static-2.65918",
  "reporting-visualizations": "/reporting-visualizations/static-1.60723",
  "trial-components-library": "/trial-components-library/static-1.14043",
  "trellis-theming": "/trellis-theming/static-1.1226",
  "ui-addon-teams": "/ui-addon-teams/static-1.21867",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.469",
  "magpie-lib": "/magpie-lib/static-1.5727",
  "navigation-components": "/navigation-components/static-1.18736",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1604",
  "magpie-types": "/magpie-types/static-1.5187",
  "simple-logging-lib": "/simple-logging-lib/static-1.3310",
  "fail-safe": "/fail-safe/static-1.213",
  "app-governance-lib": "/app-governance-lib/static-1.2320",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10763",
  "purchase-motions-components": "/purchase-motions-components/static-1.6298",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10084",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6033",
  "usage-tracker-public": "/usage-tracker-public/static-1.7427",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3957",
  "reference-resolvers": "/reference-resolvers/static-1.8439",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4180",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.597",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3266",
  "final-form": "/final-form/static-1.75",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "simple-data-table": "/simple-data-table/static-1.3460",
  "atom": "/atom/static-1.5345",
  "merchandise-lib": "/merchandise-lib/static-1.274",
  "salesImages": "/salesImages/static-1.531",
  "codemirror": "/codemirror/static-5.99",
  "react-codemirror": "/react-codemirror/static-1.10898",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5014",
  "content-assistance-lib": "/content-assistance-lib/static-1.8146",
  "content-media-capture": "/content-media-capture/static-1.5341",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10087",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24394",
  "growth-payments-core": "/growth-payments-core/static-1.26100",
  "knowledge-content-types": "/knowledge-content-types/static-1.8627",
  "payment-link-components": "/payment-link-components/static-1.24097",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20250",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10145",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9343",
  "video-components-external": "/video-components-external/static-1.12085",
  "video-data-lib": "/video-data-lib/static-1.35743",
  "navigation-messaging": "/navigation-messaging/static-1.8063",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58639",
  "react-dnd-compat": "/react-dnd-compat/static-1.4875",
  "batch-promise": "/batch-promise/static-1.1800",
  "crm-component-utils": "/crm-component-utils/static-1.39754",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6149",
  "customer-data-properties": "/customer-data-properties/static-1.52469",
  "external-options-client-types": "/external-options-client-types/static-1.4312",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7152",
  "property-value-citations": "/property-value-citations/static-1.3083",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8360",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10545",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "cms-field-types": "/cms-field-types/static-1.5074",
  "content-icons-ui": "/content-icons-ui/static-1.2323",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.224",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.818",
  "pulse": "/pulse/static-1.883",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7508",
  "crm-message-bus": "/crm-message-bus/static-1.43669",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23228",
  "events-data-lib": "/events-data-lib/static-1.500",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4986",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4193",
  "hs-resources": "/hs-resources/static-1.450",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1256",
  "onboarding-scopes": "/onboarding-scopes/static-1.6713",
  "onboarding-tours": "/onboarding-tours/static-1.17059",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14391",
  "academy-common-lib": "/academy-common-lib/static-1.14863",
  "dashboard-lib": "/dashboard-lib/static-1.82674",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19144",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18887",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8964",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11355",
  "user-context": "/user-context/static-1.5375",
  "reporting-plugins": "/reporting-plugins/static-1.10685",
  "reporting-reports": "/reporting-reports/static-1.68325",
  "hubs-service-types": "/hubs-service-types/static-1.1518",
  "purchase-motions-api": "/purchase-motions-api/static-1.6301",
  "signup-constants": "/signup-constants/static-1.19537",
  "idb-keyval": "/idb-keyval/static-1.48",
  "reactive-lib": "/reactive-lib/static-1.981",
  "nest": "/nest/static-1.495",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.582",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.164",
  "framework-listing-lib": "/framework-listing-lib/static-2.29407",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31359",
  "apps-service-types": "/apps-service-types/static-1.4000",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8319",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5273",
  "one-click-checkout": "/one-click-checkout/static-1.321",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7862",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15213",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10016",
  "redux-thunk": "/redux-thunk/static-2.77",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-flip-move": "/react-flip-move/static-1.75",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29239",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13145",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4685",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.653",
  "ui-addon-opt": "/ui-addon-opt/static-4.8625",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6553",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5340",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3788",
  "data-token-picker": "/data-token-picker/static-1.16832",
  "FileManagerLib": "/FileManagerLib/static-1.40034",
  "content-media-compositions": "/content-media-compositions/static-2.17152",
  "media-bridge-lib": "/media-bridge-lib/static-1.19351",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22702",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3436",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7127",
  "card-properties-lib": "/card-properties-lib/static-1.44929",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37702",
  "crm-actions": "/crm-actions/static-1.6610",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44426",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9874",
  "customer-data-tracking": "/customer-data-tracking/static-1.7141",
  "calling-global-api": "/calling-global-api/static-1.65426",
  "calling-internal-common": "/calling-internal-common/static-1.31577",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66808",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59102",
  "commerce-products-lib": "/commerce-products-lib/static-1.10439",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3985",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4489",
  "crm-links": "/crm-links/static-1.6585",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4319",
  "formula-editor": "/formula-editor/static-1.14691",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4396",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.894",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3879",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49575",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4154",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.53",
  "smart-property-lib": "/smart-property-lib/static-1.8200",
  "tiered-pricing": "/tiered-pricing/static-1.1891",
  "topics-actions-lib": "/topics-actions-lib/static-1.424",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11245",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.271",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7057",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.386",
  "event-emitter": "/event-emitter/static-1.1213",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1587",
  "growth-data-modal": "/growth-data-modal/static-1.5835",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3322",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2620",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1125",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7905",
  "academy-service-client": "/academy-service-client/static-1.3948",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39893",
  "SafeStorage": "/SafeStorage/static-1.4664",
  "video-embed": "/video-embed/static-1.36577",
  "redux-actions": "/redux-actions/static-3.68",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24935",
  "viral-links-lib": "/viral-links-lib/static-1.7332",
  "nested-table": "/nested-table/static-1.494",
  "timezone-utils": "/timezone-utils/static-2.5506",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18262",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10028",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5587",
  "customer-data-views-management": "/customer-data-views-management/static-1.25954",
  "framework-data-table": "/framework-data-table/static-2.12475",
  "nudge-client-utils": "/nudge-client-utils/static-1.3087",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1436",
  "switchboard-lib": "/switchboard-lib/static-1.474",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1508",
  "app-users-service-client": "/app-users-service-client/static-1.5879",
  "app-users-service-types": "/app-users-service-types/static-1.5287",
  "mini-checkout-client": "/mini-checkout-client/static-1.27416",
  "onboarding-utils": "/onboarding-utils/static-1.5623",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2118",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29224",
  "checkout-sdk": "/checkout-sdk/static-3.24259",
  "payment-method-components": "/payment-method-components/static-1.7105",
  "touchless-buying-components": "/touchless-buying-components/static-1.6127",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3745",
  "edison-service-client-types": "/edison-service-client-types/static-1.651",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6844",
  "audio-components": "/audio-components/static-1.6287",
  "FileManagerImages": "/FileManagerImages/static-1.37545",
  "video-components": "/video-components/static-1.14087",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92750",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46666",
  "enrichment-lib": "/enrichment-lib/static-1.187",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4523",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1779",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20026",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19150",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10977",
  "crm-fe-perf": "/crm-fe-perf/static-1.23159",
  "calling-error-reporting": "/calling-error-reporting/static-1.31584",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11298",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6798",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1937",
  "commerce-permissions": "/commerce-permissions/static-1.1036",
  "products-iframe-lib": "/products-iframe-lib/static-1.8518",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10929",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6701",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10630",
  "sales-views-client-types": "/sales-views-client-types/static-1.4516",
  "bark-lib": "/bark-lib/static-1.16766",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.588",
  "policy-lib": "/policy-lib/static-1.7055",
  "react-tinymce": "/react-tinymce/static-1.55902",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10693",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55028",
  "tinymce-plugins": "/tinymce-plugins/static-1.58142",
  "tinymce-themes": "/tinymce-themes/static-1.56998",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2436",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2648",
  "user-context-client": "/user-context-client/static-1.4768",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4792",
  "outpost": "/outpost/static-1.4419",
  "draft-convert": "/draft-convert/static-2.77",
  "draft-extend": "/draft-extend/static-3.80",
  "draft-js": "/draft-js/static-5.82",
  "draft-plugins": "/draft-plugins/static-2.22101",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4105",
  "ts-utils-lib": "/ts-utils-lib/static-1.426",
  "crm-export-dialog": "/crm-export-dialog/static-1.6543",
  "crm-view-components": "/crm-view-components/static-1.1024",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.67",
  "customer-data-associations": "/customer-data-associations/static-1.7587",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.45",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2844",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3163",
  "whisper-core-api": "/whisper-core-api/static-1.7255",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15482",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46770",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.835",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4251",
  "company-details-components": "/company-details-components/static-1.6460",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.816",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15573",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3718",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "crm_universal": "/crm_universal/static-1.22441",
  "customer-data-email": "/customer-data-email/static-1.18468",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37896",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40125",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13201",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55580",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22116",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18722",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72761",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5592",
  "data-agent-utils": "/data-agent-utils/static-1.249",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10134",
  "utility-belt": "/utility-belt/static-1.2790",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23728",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7942",
  "customer-data-rte": "/customer-data-rte/static-1.33581",
  "cv-backend-services": "/cv-backend-services/static-1.1590",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6210",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5366",
  "qrcode-generator": "/qrcode-generator/static-1.73",
  "quotes-client-types": "/quotes-client-types/static-1.38851",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36714",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16290",
  "hub-http-contrib": "/hub-http-contrib/static-1.3296",
  "interframe": "/interframe/static-3.5015",
  "tinymce-data": "/tinymce-data/static-1.41113",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5475",
  "layout-dnd-components": "/layout-dnd-components/static-1.12906",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11881",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16277",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9234",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7869",
  "access-control-lib": "/access-control-lib/static-1.10696",
  "EmailComponents": "/EmailComponents/static-1.55477",
  "EmailData": "/EmailData/static-1.54155",
  "redux-less": "/redux-less/static-2.9737",
  "company-details-service-types": "/company-details-service-types/static-1.4198",
  "segments-query-core": "/segments-query-core/static-1.1683",
  "pricing-pages-api": "/pricing-pages-api/static-1.15438",
  "sequences-lib": "/sequences-lib/static-1.8481",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10616",
  "products-ui-components": "/products-ui-components/static-1.40957",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7484",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55596",
  "commerce-products-api": "/commerce-products-api/static-1.2648",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57654",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103439",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81482",
  "stripe-connect-js": "/stripe-connect-js/static-1.75",
  "draft-content-plugins": "/draft-content-plugins/static-1.28843",
  "ContentData": "/ContentData/static-1.69138",
  "layout-data-lib": "/layout-data-lib/static-1.10206",
  "ContentComponents": "/ContentComponents/static-2.72019",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10933",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2071",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47056",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1918",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19586",
  "automation-ui-types": "/automation-ui-types/static-1.20504",
  "messaging-types-lib": "/messaging-types-lib/static-1.46793",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4767",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8338",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.797",
  "price-books-api": "/price-books-api/static-1.1657",
  "price-books-components": "/price-books-components/static-1.1715",
  "property-description-translator": "/property-description-translator/static-1.4099",
  "ramp-editor": "/ramp-editor/static-1.825",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3776",
  "totals-ui-components": "/totals-ui-components/static-1.24226",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9580",
  "advanced-menus-core": "/advanced-menus-core/static-1.15522",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12401",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34766",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6420",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7597",
  "data-token-views": "/data-token-views/static-1.16813",
  "forms-utils-lib": "/forms-utils-lib/static-1.13037",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13530",
  "simple-menus-core": "/simple-menus-core/static-1.15521",
  "simple-menus-lib": "/simple-menus-lib/static-1.17038",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7192",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7769",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.163",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3648",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2659",
  "ContentEditorUI": "/ContentEditorUI/static-2.77827",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4176",
  "web-interactives-components": "/web-interactives-components/static-1.14191",
  "web-interactives-data": "/web-interactives-data/static-1.14192",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1367",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1537",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1238",
  "line-items-api": "/line-items-api/static-1.1046",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4003",
  "FireAlarmUi": "/FireAlarmUi/static-1.4690",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4356",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22440",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21903",
  "data-studio-ubb": "/data-studio-ubb/static-1.3435",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27586",
  "content-management-data-lib": "/content-management-data-lib/static-1.5895",
  "copilot-plugins": "/copilot-plugins/static-1.11743",
  "cta-picker": "/cta-picker/static-1.37017",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3806",
  "editor-components": "/editor-components/static-1.13594",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8746",
  "error-messaging-js": "/error-messaging-js/static-1.5456",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86489",
  "pictos": "/pictos/static-7.190",
  "react-transition-group": "/react-transition-group/static-2.69",
  "redux-request-state": "/redux-request-state/static-1.10909",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2006",
  "smart-content-core": "/smart-content-core/static-1.43101",
  "smart-content-lib": "/smart-content-lib/static-1.43754",
  "social-composer-lib": "/social-composer-lib/static-1.60135",
  "structured-content-lib": "/structured-content-lib/static-1.25849",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53877",
  "tinymce-copilot": "/tinymce-copilot/static-1.17096",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8218",
  "automation-ui-routing": "/automation-ui-routing/static-1.21861",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5858",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42720",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3462",
  "reporting-enablement": "/reporting-enablement/static-1.23747",
  "forms-ai-lib": "/forms-ai-lib/static-1.4707",
  "codemirror-dlb": "/codemirror-dlb/static-1.59386",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6698",
  "report-customization-components": "/report-customization-components/static-1.13832",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13712",
  "reporting-filters": "/reporting-filters/static-1.936",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2491"
}
};
